import Vue from 'vue'

import { Button, Form, FormItem, Input, Cascader, MessageBox,Link } from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Cascader)
Vue.use(Link)

Vue.prototype.$confirm = MessageBox.confirm;
